import React from "react";
import { AiOutlineCloudUpload } from "react-icons/ai";
import moment from "moment";
// import TextEditor from "../../common/TextEditor";
export default function AddNotesConversation({
  handleMessageSubmit,
  state,
  onInputChange,
  errors,
  handleBulkFileChange,
  handleRemoveFile,
  fileNames,
  setState,
  isApiLoading
}) {
  return (
    <div>
      <div className="mail-file-attachments">
        {fileNames.length === 0
          ? null
          : fileNames.map((fileName) => (
            <div key={fileName} className="mail-file-attachment">
              <p>{fileName}</p>
              <button
                type="button"
                className="mail-remove-file"
                onClick={() => handleRemoveFile(fileName)}
              >
                X
              </button>
            </div>
          ))}
      </div>
      <form onSubmit={() => { if (!isApiLoading) { handleMessageSubmit() } }} className="chat-input px-3 py-3">
        <div className="text_msg_box w-100">
          <textarea
            placeholder="Type your message..."
            value={state.message}
            onChange={onInputChange}
            name="message"
            className={`message_input_box ${errors.message && "border border-danger"
              }`}
            disabled={state.DocUrl}
          ></textarea>
          {/* <TextEditor
            setState={setState}
            state={state}
            page={"addAgentConversation"} /> */}
        </div>

        <div className="text_msg_control">
          <input
            type="text"
            placeholder="Subject"
            value={state.subject}
            onChange={onInputChange}
            className={`message_input d-none ${errors.Subject && "border border-danger"
              }`}
            name="subject"
            title="Add Subject in Message"
          />
          <input
            type="date"
            placeholder="Next Follow-up Date"
            value={state.nxtfollowupdate}
            onChange={onInputChange}
            min={moment().format("DD-MM-YYYY")}
            onKeyDownCapture={(e) => e.preventDefault()}
            className={`message_input d-none coustam_datepicker ${errors.nxtfollowupdate && "border border-danger"
              }`}
            title="Next Followup Date"
            name="nxtfollowupdate"
          />

          {/* <select
            name="status"
            value={state.status || ""}
            onChange={onInputChange}
            type="text"
            title="Select status"
            className={`message_input ${
              errors.status && "border border-danger"
            }`}
            placeholder="status"
            disabled={state.DocUrl}
            id="status"
          >
            <option value={"normal"}>Normal</option>
            <option value={"private"}>Private</option>
          </select> */}
        </div>
        <div className="">
          <label className="btn btn-light doc_btn">
            <AiOutlineCloudUpload className="font-size-3 mr-2" />
            <input
              type="file"
              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
              style={{ display: "none" }}
              onChange={(e) => {
                handleBulkFileChange(e);
              }}
            />
            Send files or images
          </label>
        </div>
        {errors.general && <p className="error-message">{errors.general}</p>}
        {isApiLoading ?
          <button
            className="send-button btn btn-primary"
            type="button"
            disabled
          >
            <span
              className="spinner-border spinner-border-sm "
              role="status"
              aria-hidden="true"
            ></span>
            <span className="sr-only">Loading...</span>
          </button> : <button type="button" onClick={(e) => { if (!isApiLoading) { handleMessageSubmit(e) } }} className="send-button btn btn-primary">
            <i className="fas fa-angle-double-right"></i>
          </button>}
      </form>
    </div>
  );
}
